import React, { useCallback, useEffect, useState } from 'react';
import './ChatBotPluginWidget.scss';
import Alert from '@mui/material/Alert';
import { api } from '../../frontend/components/api';
import globalTranslationManager from '../../translation/frontend/components/translation_manager';
import { ChatWithBotWidget } from './ChatWithBotWidget';
import { WebChatPluginButton } from './WebChatPluginButton';
import { WebChatPluginPopup } from './WebChatPluginPopup';

export default function IntakeBotPluginWidget({ intakeToken, fullscreen }) {
  const [conversation, setConversation] = useState(null);
  const [webChatConfiguration, setWebChatConfiguration] = useState(null);
  const [error, setError] = useState(null);
  const [isShowingWebChat, setIsShowingWebChat] = useState(false);

  const resetConversation = useCallback(async () => {
    try {
      const conversation = await api.startIntakeChatConversation({
        intake_token: intakeToken,
        communication_channel: 'web_chat',
        initiate_conversation: true,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language_id: globalTranslationManager.getLocalLanguage(),
      });
      setError(null);
      setConversation(conversation);
      localStorage.setItem(
        `web_chat_conversation_id_${intakeToken}`,
        conversation._id
      );
      localStorage.setItem(
        `web_chat_conversation_token_${intakeToken}`,
        conversation.metadata.conversation_token
      );
    } catch (error) {
      setError(error);
    }
  }, [intakeToken, fullscreen]);

  useEffect(() => {
    if (!conversation) {
      // Check if there is a conversation id in local storage. If so, try to load that conversation
      const conversationId = localStorage.getItem(
        `web_chat_conversation_id_${intakeToken}`
      );
      const conversationToken = localStorage.getItem(
        `web_chat_conversation_token_${intakeToken}`
      );
      if (conversationId) {
        api
          .getIntakeChatConversation(conversationId, conversationToken)
          .then((conversation) => {
            if (conversation.status === 'completed') {
              resetConversation();
            } else {
              setConversation(conversation);
              setError(null);
            }
          })
          .catch((error) => {
            resetConversation();
          });
      } else {
        resetConversation();
      }
    }
  }, [intakeToken, conversation, resetConversation]);

  if (!conversation) {
    return <Alert severity="info">Loading conversation...</Alert>;
  }

  return (
    <>
      {fullscreen ? (
        <div className="prospera-full-screen-web-chat-plugin-popup">
          <ChatWithBotWidget
            conversation={conversation}
            webChatConfiguration={webChatConfiguration}
            showResetButton={true}
            onResetClicked={resetConversation}
            showInternalEvents={false}
            showBoundingBox={true}
          />
        </div>
      ) : (
        <>
          {webChatConfiguration ? (
            <WebChatPluginButton
              onClick={() => setIsShowingWebChat(!isShowingWebChat)}
              webChatConfiguration={webChatConfiguration}
              hideTooltip={isShowingWebChat}
            />
          ) : null}
          {isShowingWebChat && conversation ? (
            <WebChatPluginPopup
              conversation={conversation}
              webChatConfiguration={webChatConfiguration}
              showResetButton={true}
              onResetClicked={resetConversation}
            />
          ) : null}
          {error ? <Alert severity="error">{error.message}</Alert> : null}
        </>
      )}
    </>
  );
}
